import { Component, Input, OnInit } from '@angular/core';

import { isStatusNaoConfirmada, isStatusEmAnalise, isStatusReprovada, isStatusEmAndamento, isStatusEmRevisao, isStatusEncerrada } from '../campanha-status';

interface Config {
    isNaoConfirmada: boolean;
    isEmAnalise: boolean;
    isReprovada: boolean;
    isEmAndamento: boolean;
    isEmRevisao: boolean;
    isEncerrada: boolean;
}

@Component({
    selector: 'sgt-campanha-status-badge',
    templateUrl: './campanha-status-badge.component.html',
    styleUrls: ['./campanha-status-badge.component.less']
})
export class CampanhaStatusBadgeComponent implements OnInit {
    config: Config;

    /** Status da campanha */
    @Input() status: number;
    /** Tamanho da font */
    @Input() fontSize = '8px';

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isNaoConfirmada: isStatusNaoConfirmada(this.status),
            isEmAnalise: isStatusEmAnalise(this.status),
            isReprovada: isStatusReprovada(this.status),
            isEmAndamento: isStatusEmAndamento(this.status),
            isEmRevisao: isStatusEmRevisao(this.status),
            isEncerrada: isStatusEncerrada(this.status)
        }
    }
}
